import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "components/modal";
import CloseIcon from "assets/icons/close.svg";
import { Button } from "components/button";
import WeightInput from "components/weight-input";
import { useTranslation } from "react-i18next";
import AuthContext from "contexts/AuthContext";

export default function StoreShipmentModal({ setModalOpen, modalOpen }) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { user } = useContext(AuthContext);
  const [weight, setWeight] = useState("");

  const unit = `${t("scale.weight")}`;

  const handleWeightChange = (e) => {
    setWeight(e.target.value);
  };

  const onCreateLabel = () => {
    if (!weight) return;

    // Get current language from URL or i18n
    const currentLang = i18n.language === "de" ? "de-DE" : "en-US";

    // Close modal and navigate to loading page with weight data
    setModalOpen(false);
    navigate(`/${currentLang}/store/creating-shipping-label`, {
      state: {
        weight: parseFloat(weight),
        uom: "lbs",
        type: "MAIL_LABEL",
        store_location: user?.state,
      },
    });
  };

  return (
    <Modal
      setModalOpen={setModalOpen}
      modalOpen={modalOpen}
      className="flex flex-col justify-between max-h-[90vh]"
    >
      <div className="flex flex-col space-y-6">
        <div className="flex justify-between items-start">
          <div className="flex flex-col space-y-2">
            <h2 className="text-4xl font-semibold leading-none">
              Create shipping label
            </h2>
          </div>
          <div className="cursor-pointer" onClick={() => setModalOpen(false)}>
            <img src={CloseIcon} alt="Close" />
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <WeightInput
            caption="Total weight"
            unit={unit}
            value={weight}
            onChange={handleWeightChange}
            className="w-full"
          />
        </div>
      </div>

      <div className="flex justify-between mt-6">
        <Button variant="secondary" onClick={() => setModalOpen(false)}>
          Cancel
        </Button>
        <Button onClick={onCreateLabel} disabled={!weight}>
          Confirm
        </Button>
      </div>
    </Modal>
  );
}
